import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { APP_MEDIA_REWARDS_LIST } from 'src/constants/queryKeys';

export const networkGetMediaRewards = async (ApplicationID) => {
  const res = await axiosInstance.post(`MediaRewards/List/${ApplicationID}`);
  return res;
};

export function useFetchMediaRewards(ApplicationID) {
  return useQuery({
    queryKey: [APP_MEDIA_REWARDS_LIST],
    queryFn: () => networkGetMediaRewards(ApplicationID),
  });
}

export const networkGetMediaRewardsInsert = async (payload) => {
  const res = await axiosInstance.post(`MediaRewards/Insert`, payload);
  return res;
};

export const networkGetMediaRewardsUpdate = async (id, payload) => {
  const res = await axiosInstance.post(`MediaRewards/Update/${id}`, payload);
  return res;
};

export const networkGetMediaRewardsRemove = async (id) => {
  const res = await axiosInstance.post(`MediaRewards/Remove/${id}`);
  return res;
};
